import { LitElement } from "lit-element";

export class ModuleBase extends LitElement {
	fireOnDraw() {
		this.canvas.fire("module-draw", {
			name: this.constructor.name,
			target: this
		});
	}
}
